const STORAGE_KEY = "stratagemHeroStats";

const baseStats = {
  overall: {
    attempts: 0,
    successes: 0,
    totalTimeMs: 0,
    totalInputs: 0,
    bestTimeMs: null,
    longestStreak: 0,
  },
  byStratagem: {},
  history: [],
};

const cloneStats = () => JSON.parse(JSON.stringify(baseStats));

export const loadStats = () => {
  if (typeof window === "undefined") {
    return cloneStats();
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return cloneStats();
    }
    const parsed = JSON.parse(raw);
    return { ...cloneStats(), ...parsed };
  } catch (error) {
    return cloneStats();
  }
};

export const saveStats = (stats) => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
};

export const updateStats = ({ stratagem, success, timeMs, inputsCount, streak }) => {
  const stats = loadStats();
  stats.overall.attempts += 1;
  const safeTime = Math.max(timeMs || 0, 0);

  if (success) {
    stats.overall.successes += 1;
    stats.overall.totalTimeMs += safeTime;
    stats.overall.totalInputs += inputsCount || 0;
    if (!stats.overall.bestTimeMs || safeTime < stats.overall.bestTimeMs) {
      stats.overall.bestTimeMs = safeTime;
    }
  }

  stats.overall.longestStreak = Math.max(stats.overall.longestStreak, streak || 0);

  const existing = stats.byStratagem[stratagem.id] || {
    id: stratagem.id,
    name: stratagem.name,
    category: stratagem.category,
    attempts: 0,
    successes: 0,
    totalTimeMs: 0,
    totalInputs: 0,
    bestTimeMs: null,
    bestStreak: 0,
  };

  existing.attempts += 1;
  if (success) {
    existing.successes += 1;
    existing.totalTimeMs += safeTime;
    existing.totalInputs += inputsCount || 0;
    if (!existing.bestTimeMs || safeTime < existing.bestTimeMs) {
      existing.bestTimeMs = safeTime;
    }
  }
  existing.bestStreak = Math.max(existing.bestStreak, streak || 0);
  stats.byStratagem[stratagem.id] = existing;

  stats.history = [
    {
      id: stratagem.id,
      name: stratagem.name,
      success,
      timeMs: safeTime,
      inputsCount: inputsCount || 0,
      timestamp: new Date().toISOString(),
    },
    ...stats.history,
  ].slice(0, 50);

  saveStats(stats);
  return stats;
};

export const resetStats = () => {
  if (typeof window !== "undefined") {
    window.localStorage.removeItem(STORAGE_KEY);
  }
  return cloneStats();
};